const currentUser = (state = null, action) => {
    switch (action.type) {
        case 'LOGGED_IN_SUCCESS':
        case 'ACCOUNT_CREATED_SUCCESS':
            return {
                ...state,
                ...action.payload.response,
                message: undefined,
            };
        case 'ACCOUNT_CREATED_ERROR':
            return {
                ...state,
                message: action.payload.response,
            };
        case 'LOGGED_IN_ERROR':
            return {
                ...state,
                message: action.payload.response,
            };
        case 'PASSWORD_UPDATE_SUCCESS':
            return {
                ...state,
                passwordUpdated: true,
            };
        case 'PASSWORD_RESET_SUCCESS':
            return {
                ...state,
                passwordResetSent: true,
            };
        case 'PASSWORD_RESET_ERROR':
            return state;
        default:
            return state;
    }
}

export default currentUser;



// WEBPACK FOOTER //
// ./src/reducers/currentUser.js